import script from "./listExam.vue?vue&type=script&setup=true&lang=js"
export * from "./listExam.vue?vue&type=script&setup=true&lang=js"

import "./listExam.vue?vue&type=style&index=0&id=b7620c58&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7620c58"]])

export default __exports__